import { useMutation } from '@tanstack/react-query';
import { sendRequest } from 'api/sendRequest';

import { endpoints } from 'constants/endpoints';

export const realignOKRApi = ({
  realignId,
  targetId,
  timeBoundPeriod,
  isDeleteRealign = false,
  performChildrenRealign = false,
}) => {
  const url = endpoints.rabbitGoals.realign;
  const { startTS, endTS, timelineTag } = timeBoundPeriod;
  return sendRequest({
    method: 'POST',
    url,
    queryParams: {
      realignId,
      targetId,
      startTS,
      endTS,
      timelineTag,
      isDeleteRealign,
      performChildrenRealign,
    },
    credentials: 'include',
  });
};

export const useOKRRealignMutation = (uuid) =>
  useMutation({
    mutationFn: async ({ selectedParentUuid, timeBoundPeriod, performChildrenRealign }) =>
      realignOKRApi({
        realignId: uuid,
        targetId: selectedParentUuid,
        timeBoundPeriod,
        performChildrenRealign,
      }),
    /* 
    Commenting this for now as to support optimistic updates,
    have to be think about what would happen on delete and realign scenarios.
    onMutate: ({ updates }) => {
      queryClient.cancelQueries(queryKey);

      const previousKR = queryClient.getQueryData(queryKey);
      queryClient.setQueryData(queryKey, (previousKR) => {
        return { ...previousKR, parentPost: {

        }};
      });
      return { previousKR };
    }, */
  });
